import { createSelector } from 'reselect';
import { getFormValues, getFormSyncErrors } from 'redux-form';

import { getPassengersValues } from './common';
import { mapCountry } from '../utility/getSuggestOptions';

const getSuggest = (state) => state.railways.suggest || {};
const getAges = (state) => state.railways.ages;
const getRoundTrip = (state) => state.railways.roundTrip;
const getInitialValues = (state, props) => props.initialValues;

const valuesSelector = getFormValues('RailwaysSearchForm');
const errorsSelector = getFormSyncErrors('RailwaysSearchForm');

const searchFormSelector = createSelector(
  getSuggest,
  getAges,
  valuesSelector,
  errorsSelector,
  getPassengersValues,
  getRoundTrip,
  getInitialValues,
  (
    suggest,
    ages,
    formValues,
    formErrors,
    passengersValues,
    roundTripStatus,
    initialValues = {}
  ) => ({
    fromSuggest: suggest.from || {},
    toSuggest: suggest.to || {},
    formValues,
    formErrors,
    ages,
    passengersValues,
    roundTripStatus,
    initialValues: {
      ...initialValues,
      from: mapCountry(initialValues.from),
      to: mapCountry(initialValues.to),
      dates: {
        ...initialValues.dates,
        startDate: initialValues.dates?.startDate,
      },
    },
  })
);

export default searchFormSelector;
